// Phase 24 M4 — verify-email landing.
//
// Reads `?token=` from the URL and calls `GET /auth/verify-email`. Shows
// success / failure state and a link back to /marketplace.

import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import { verifyEmail } from '../api/auth';

type Status = 'pending' | 'ok' | 'error';

export default function VerifyEmailPage(): JSX.Element {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const [status, setStatus] = useState<Status>('pending');
  const [email, setEmail] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    if (!token) {
      setStatus('error');
      setMessage('Falta o token de verificación.');
      return;
    }
    verifyEmail(token)
      .then((res) => {
        if (cancelled) return;
        setStatus('ok');
        setEmail(res.email);
      })
      .catch(() => {
        if (cancelled) return;
        setStatus('error');
        setMessage('O enlace caducou ou xa foi usado.');
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <main
      className="min-h-[60vh] flex items-center justify-center px-6 py-12"
      style={{ background: '#F7F7F7', color: '#222222' }}
    >
      <div
        className="max-w-md w-full p-8 rounded-2xl text-center"
        style={{
          background: '#FFFFFF',
          border: '1px solid #DDDDDD',
          boxShadow: 'var(--shadow-card)',
          borderRadius: 'var(--radius-lg)',
        }}
      >
        {status === 'pending' ? (
          <p>Comprobando o token…</p>
        ) : status === 'ok' ? (
          <>
            <h1 className="text-2xl font-semibold mb-2" style={{ color: '#2D6E1A' }}>
              Email confirmado
            </h1>
            <p className="text-sm mb-6" style={{ color: '#717171' }}>
              {email
                ? `O enderezo ${email} quedou verificado.`
                : 'O teu enderezo quedou verificado.'}
            </p>
            <Link
              to="/marketplace"
              className="inline-block px-4 py-2 rounded-md font-semibold"
              style={{
                background: '#2D6E1A',
                color: '#FFFFFF',
              }}
            >
              Ir ao marketplace
            </Link>
          </>
        ) : (
          <>
            <h1 className="text-2xl font-semibold mb-2" style={{ color: '#B23A3A' }}>
              Non puido verificarse
            </h1>
            <p className="text-sm" style={{ color: '#717171' }}>
              {message ?? 'Non se puido completar a verificación.'}
            </p>
          </>
        )}
      </div>
    </main>
  );
}
